import { render, staticRenderFns } from "./design-expend-filter.vue?vue&type=template&id=c8f735bc&scoped=true"
import script from "./design-expend-filter.vue?vue&type=script&lang=js"
export * from "./design-expend-filter.vue?vue&type=script&lang=js"
import style0 from "./design-expend-filter.vue?vue&type=style&index=0&id=c8f735bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f735bc",
  null
  
)

export default component.exports